import { OpenCall, OpenCallStatus } from '@repo/api/open-calls/graphql';

export class OpenCallModel implements OpenCall {
  id;
  name;
  isAmericanStyleOpenCall;
  typeId;
  status;
  totalApplicants?;
  createdAt;
  closedAt;
  brand: Brand;
  stages;
  defaultStageId;

  constructor({
    id,
    name,
    isAmericanStyleOpenCall = false,
    typeId,
    status,
    totalApplicants,
    createdAt,
    closedAt,
    brand,
    stages,
    defaultStageId,
  }: Omit<OpenCall, 'createdAt' | 'closedAt' | 'isAmericanStyleOpenCall'> & {
    createdAt: Date | string;
    closedAt: Date | string;
    isAmericanStyleOpenCall?: boolean;
    typeId?: null | string;
  }) {
    this.id = id;
    this.name = name;
    this.isAmericanStyleOpenCall = isAmericanStyleOpenCall;
    this.typeId = typeId;
    this.status = status;
    this.totalApplicants = totalApplicants;
    this.createdAt = createdAt;
    this.closedAt = closedAt;
    this.brand = brand;
    this.stages = stages;
    this.defaultStageId = defaultStageId;
  }

  public get isLive() {
    return this.status === OpenCallStatus.Live;
  }
}

type Brand = {
  organizationId: string;
  logoURL: string;
  name: string;
};
